export const InputType = {
  Text: 'text',
  Number: 'number',
  Email: 'email',
  Password: 'password',
  Date: 'date',
  Time: 'time',
  DateTimeLocal: 'datetime-local',
  Color: 'color',
  Range: 'range',
  Tel: 'tel',
  Url: 'url',
  Search: 'search',
  File: 'file',
  Checkbox: 'checkbox',
  Radio: 'radio',
  Select: 'select',
  Textarea: 'textarea'
} as const;

// Exportamos los tipos para TypeScript
export type InputType = (typeof InputType)[keyof typeof InputType];
